<app-sidebar [hidden]="!isUserSignedIn"></app-sidebar>
<div class="main-content">
  <app-topbar [hidden]="!isUserSignedIn"></app-topbar>
  <div class="page-content">
    <router-outlet></router-outlet>
  </div>
</div>
